import {
  type CreateStoreEnhancer,
  type EventBusListeners,
  type Reducer,
  type State,
  type Store,
  createStore,
  EventBus,
  DialogSchedule,
  type AxiosRequestConfig,
  type AxiosResponse,
  type AxiosError,
  FetchWithAxios
} from "@zyzgroup/core-common";

export type ContextConfig<E> = {
  store?: {
    state?: State;
    reducer?: Reducer;
    enhancer?: CreateStoreEnhancer;
    immutable?: boolean;
  };

  axios?: {
    baseURL?: string;
    // 毫秒
    timeout?: number;
    // {
    //   "Content-Type": "application/json;charset=UTF-8",
    //   "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    //   "Content-Type": "multipart/form-data",
    //   "Content-Type": "application/octet-stream",
    //   Accept: "application/json",
    //   Authentication: "Bearer efded2d72a664f9799e08266d801000c",
    // }
    headers?: {
      [key: string]: string;
    };
    responseType?:
      | "arraybuffer"
      | "blob"
      | "document"
      | "json"
      | "text"
      | "stream";
    // | "formdata";
    responseEncoding?:
      | "ascii"
      | "ASCII"
      | "ansi"
      | "ANSI"
      | "binary"
      | "BINARY"
      | "base64"
      | "BASE64"
      | "base64url"
      | "BASE64URL"
      | "hex"
      | "HEX"
      | "latin1"
      | "LATIN1"
      | "ucs-2"
      | "UCS-2"
      | "ucs2"
      | "UCS2"
      | "utf-8"
      | "UTF-8"
      | "utf8"
      | "UTF8"
      | "utf16le"
      | "UTF16LE";
    // 自定义拦截器 request response 监控
    interceptor?: {
      request?: (config: AxiosRequestConfig) => void;
      requestError?: (error: AxiosError) => void;
      response?: (response: AxiosResponse) => void;
      responseError?: (error: AxiosError) => void;
    };
    // 请求失败时，重新尝试的次数
    retry?: number;
    // 请求成功时，结果缓存的秒数
    cache?: number;
  };

  // 常量
  static?: Record<string, string | number | any>;
};

export class Context<E extends EventBusListeners = EventBusListeners> {
  public static: Record<string, string | number | any>;
  public store: Store;
  public eb: EventBus<E>; // 多对多
  public axios: FetchWithAxios;
  public ds: DialogSchedule;

  constructor(config: ContextConfig<E> = {}) {
    this.static = config.static || {};

    const state = config.store?.state || {};
    this.store = createStore({
      reducer: config.store?.reducer || (() => state),
      initState: state,
      enhancer: config.store?.enhancer,
      immutable:
        typeof config.store?.immutable == "boolean"
          ? config.store?.immutable
          : true
    });

    this.eb = new EventBus<E>();

    this.axios = new FetchWithAxios({
      baseURL: config.axios?.baseURL,
      timeout: config.axios?.timeout,
      headers: config.axios?.headers,
      responseType: config.axios?.responseType,
      responseEncoding: config.axios?.responseEncoding,
      interceptor: config.axios?.interceptor,
      retry: config.axios?.retry,
      cache: config.axios?.cache
    });

    this.ds = new DialogSchedule({ concurrency: 1 });
  }
}
